import React from "react";
import PropTypes from "prop-types";
import styled from "react-emotion";
import ReactShow from "react-show";

import { dataGradient, colors } from "../consts";
import { MarkdownStringContent } from "./Content";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;
const Content = styled.div`
  width: 320px;
  padding-left: 30px;
  border-left: 1px solid #dbdcde;
`;
const LegendBar = styled.div`
  width: 100%;
  height: 24px;
  background-image: ${({ reverse }) =>
    dataGradient[reverse ? "reverse" : "normal"]};
`;
const LegendFlex = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 4px;
`;
const LegendText = styled.div`
  color: ${colors.primaryDark};
  font-size: 12px;
`;
const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 15px;
`;
const InfoButton = styled.button`
  margin-top: 6px;
  font-size: 14px;
  color: ${colors.active};
  background: none;
  border: none;
  padding: 3px 0;
  transition-duration: 0.2s;
  cursor: pointer;
  &:hover {
    color: ${colors.primaryDark};
  }
`;
const Icon = styled.i`
  display: inline-block;
  margin-left: 6px;
  font-size: 12px;
  transition: transform 0.2s;
`;
const InfoContent = styled(MarkdownStringContent)`
  margin: 6px 0 18px 0;
  p,
  ol,
  ul {
    font-size: 12px;
  }
`;

const flipStyle = flipped =>
  flipped ? { transform: "rotateX(180deg)" } : { transform: "rotateX(0)" };

export default class IndicatorInfo extends React.Component {
  static propTypes = {
    indicator: PropTypes.object.isRequired,
    indicatorData: PropTypes.object.isRequired
  };

  state = { show: null };

  toggleNotes = e => {
    this.setState(
      prevState =>
        prevState.show === "notes" ? { show: null } : { show: "notes" }
    );
  };

  toggleSource = e => {
    this.setState(
      prevState =>
        prevState.show === "source" ? { show: null } : { show: "source" }
    );
  };

  render() {
    const {
      toggleSourceModal,
      toggleNotesModal,
      indicator,
      indicatorData
    } = this.props;
    const { title, dataKey, description, notes, source } = indicator;
    const { lowerIsBetter, minString, maxString } = indicatorData;
    const showSource = this.state.show === "source";
    const showNotes = this.state.show === "notes";
    return (
      <Wrapper>
        <Content>
          <h6>{title}</h6>
          <h3>{description}</h3>
          <LegendBar reverse={lowerIsBetter} />
          <LegendFlex>
            <LegendText>{minString}</LegendText>
            <LegendText>{maxString}</LegendText>
          </LegendFlex>
          <InfoContainer>
            <InfoButton onClick={this.toggleSource}>
              Source{" "}
              <Icon
                className="icon-arrow-down icons"
                style={flipStyle(showSource)}
              />
            </InfoButton>
            <ReactShow show={showSource}>
              <InfoContent content={source} />
            </ReactShow>
            <InfoButton onClick={this.toggleNotes}>
              Notes{" "}
              <Icon
                className="icon-arrow-down icons"
                style={flipStyle(showNotes)}
              />
            </InfoButton>
            <ReactShow show={showNotes}>
              <InfoContent content={notes} />
            </ReactShow>
          </InfoContainer>
        </Content>
      </Wrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/IndicatorInfo.js